// How the game ended, from the PGN's Termination header.
import { endingOf } from '../classify.ts';
import { oneOf, type FilterCriterion } from '../criterion.ts';
import { GAME_ENDINGS } from '@chess/api-model';

export const ending: FilterCriterion<'ending'> = {
  key: 'ending',
  query: 'ending',
  many: true,
  parse: oneOf(GAME_ENDINGS),
  format: (v) => v,
  matches: (game, v) => !!game.pgn && endingOf(game.pgn) === v,
  control: {
    kind: 'choice',
    order: 50,
    more: true,
    label: 'Ended by',
    options: [['checkmate', 'Mate'], ['resignation', 'Resigned'], ['time', 'Time'], ['draw', 'Draw'], ['abandoned', 'Abandoned']],
  },
};
